import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  count: {},
};

const ll55 = createSlice({
  name: "ll55",
  initialState,
  reducers: {
    setLL55StatusCount: {
      prepare(count) {
        return {
          payload: { count },
        };
      },
      reducer(state, action) {
        state.count = action.payload.count;
      },
    },
  },
});

export const { setLL55StatusCount } = ll55.actions;

export default ll55.reducer; 